// frontend/src/utils/dateKst.js
// ─────────────────────────────────────────────────────────────────────────
// "오늘 날짜"를 한국시간(KST, UTC+9) 기준으로 안전하게 구하기 위한 공용 헬퍼.
// `new Date().toISOString().slice(0,10)`은 항상 UTC 기준으로 날짜를 잘라내기 때문에, 사용자의
// 브라우저가 한국(KST)에 있어도 자정~오전 9시 사이에는 실제 날짜보다 하루 이전 날짜가 되어버리는
// 버그가 있었다(일정/업무/자산/영업 등 여러 화면의 "오늘" 기본값이 이 패턴을 쓰고 있었음).
// Intl.DateTimeFormat(timeZone: 'Asia/Seoul')을 사용하면 OS/브라우저 시간대 설정과 무관하게
// 항상 정확한 한국 날짜 문자열("YYYY-MM-DD")을 얻을 수 있다.
export function getKstDateString(dateInput) {
  const d = dateInput instanceof Date ? dateInput : (dateInput ? new Date(dateInput) : new Date());
  // 'sv-SE'(스웨덴) 로케일은 Intl.DateTimeFormat 결과가 'YYYY-MM-DD' 형식이라 그대로 사용한다.
  return new Intl.DateTimeFormat('sv-SE', { timeZone: 'Asia/Seoul' }).format(d);
}

// 자주 쓰는 "오늘" 별칭
export function todayKst() {
  return getKstDateString();
}
